export const iso2ToIso3: Record<string, string> = {
  US: 'USA',
  GB: 'GBR',
  CA: 'CAN',
  AU: 'AUS',
  NZ: 'NZL',
  // add these if you expand allowedCountries list:
  DE: 'DEU',
  HK: 'HKG',
  IE: 'IRL',
  MO: 'MAC',
  NL: 'NLD',
  PH: 'PHL',
  SG: 'SGP',
  TW: 'TWN',
  ZA: 'ZAF'
};

export const normalize = (str: string) =>
  (str || '')
    ?.toLowerCase()
    ?.normalize('NFD') // break accented letters into base + diacritic
    ?.replace(/[\u0300-\u036f]/g, '') // remove diacritics
    ?.replace(/\s+/g, ' ') // collapse multiple spaces
    ?.replace(/[^\w\s]/gi, '') // remove punctuation
    ?.trim();

export const formatWebsiteUri = (rawUri) => {
  if (!rawUri) return null;
  try {
    const urlObj = new URL(rawUri);
    return `${urlObj.protocol}//${urlObj.hostname}`;
  } catch (err) {
    return rawUri;
  }
};
